<div class="form-fields form-fields--file-attach mb-3" [class]="hostClass">
  <div class="flex justify-content-between mb-3">
    <div class="flex flex-column">
      <div class="m-bold">{{ title | translate }}</div>
      <div class="s-regular pr-0 sm:pr-8">{{ subtitle | translate }}</div>
    </div>
    @if (badgeLabel) {
      <div class="xs-medium form-fields--file-attach--badge" [class]="badgeClass">
        {{ badgeLabel | translate }}
      </div>
    }
  </div>
  <ng-content select="[fileAttachExtra]"></ng-content>
  <div class="form-fields--file-attach--files mb-2">
    @if (!files.length || !showUploadOnlyWhenEmpty) {
      <div class="flex form-fields--file-attach--files--button anadir">
        @if (!isDesktopWeb) {
          <button
            pButton
            severity="secondary"
            class="medium-40 w-full"
            type="button"
            (click)="onAppUploadClick()">
            <span>{{ appButtonLabel | translate }}</span>
          </button>
        } @else {
          <div
            class="form-fields--file-attach--dropzone w-full"
            [class.form-fields--file-attach--dropzone--active]="dropActive"
            role="button"
            tabindex="0"
            (click)="openFileDialog(fileInput)"
            (keyup.enter)="openFileDialog(fileInput)"
            (dragover)="onDragOver($event)"
            (dragleave)="onDragLeave($event)"
            (drop)="onDrop($event)">
            <label [for]="inputId" class="sr-only">{{ selectFileLabel | translate }}</label>
            <span class="form-fields--file-attach--dropzone--select s-medium">
              {{ selectFileLabel | translate }}
            </span>
            <span class="s-medium mt-2">{{ dropzoneTitle | translate }}</span>
            <p class="xs-regular mt-2 form-fields--file-attach--files--format">
              {{ formatHint | translate }}
            </p>
            <input
              #fileInput
              type="file"
              [id]="inputId"
              class="hidden"
              [accept]="accept"
              (change)="onFileInputChange($event)" />
          </div>
        }
      </div>
    }

    @if (showAddPrescription && isDesktopWeb) {
      <button type="button" class="btn-text w-full mt-2 mb-2" (click)="addPrescription.emit()">
        <span class="s-medium">{{
          'solicitud_reembolso.documentacion.usar_prescripcion_cargada' | translate
        }}</span>
      </button>
    }

    @if (files.length) {
      @if (enableReorder) {
        <div
          class="form-fields--file-attach--files--uploaded"
          cdkDropList
          (cdkDropListDropped)="onDropListDropped($event)">
          @for (file of files; track file.name + i; let i = $index) {
            @if (fileDetailTemplate) {
              <div
                cdkDrag
                class="destacado-green-border form-fields--file-attach--files--item mb-3"
                [ngClass]="itemErrorIndexes.includes(i) ? itemErrorClass : ''">
                <div
                  class="flex justify-content-between w-full relative form-fields--file-attach--files--selected pt-1">
                  <div
                    class="absolute flex align-items-center justify-content-center form-fields--file-attach--files--selected--check"
                    cdkDragHandle>
                    <app-cigna-icon icon="ok" class="size-16"></app-cigna-icon>
                  </div>
                  <span class="s-bold form-fields--file-attach--files--selected--name">
                    {{ file.name }}
                  </span>
                  <span class="xs-regular form-fields--file-attach--files--selected--size">
                    {{ fileSize(file.size) }}
                  </span>
                  <div
                    class="absolute flex align-items-center justify-content-center cursor-pointer form-fields--file-attach--files--selected--close"
                    (click)="fileRemoved.emit(i)"
                    (keyup.enter)="fileRemoved.emit(i)"
                    tabindex="0">
                    <app-cigna-icon icon="cross" class="grey"></app-cigna-icon>
                  </div>
                </div>
                <ng-container
                  [ngTemplateOutlet]="fileDetailTemplate"
                  [ngTemplateOutletContext]="{ $implicit: file, index: i }" />
              </div>
            } @else {
              <div
                cdkDrag
                class="destacado-green-border flex justify-content-between w-full relative form-fields--file-attach--files--selected">
                <div
                  class="absolute flex align-items-center justify-content-center form-fields--file-attach--files--selected--check"
                  cdkDragHandle>
                  <app-cigna-icon icon="ok" class="size-16"></app-cigna-icon>
                </div>
                <span class="s-bold form-fields--file-attach--files--selected--name">
                  {{ file.name }}
                </span>
                <span class="xs-regular form-fields--file-attach--files--selected--size">
                  {{ fileSize(file.size) }}
                </span>
                <div
                  class="absolute flex align-items-center justify-content-center cursor-pointer form-fields--file-attach--files--selected--close"
                  (click)="fileRemoved.emit(i)"
                  (keyup.enter)="fileRemoved.emit(i)"
                  tabindex="0">
                  <app-cigna-icon icon="cross" class="grey"></app-cigna-icon>
                </div>
              </div>
            }
          }
        </div>
      } @else {
        <div class="form-fields--file-attach--files--uploaded">
          @for (file of files; track file.name + i; let i = $index) {
            @if (fileDetailTemplate) {
              <div
                class="destacado-green-border form-fields--file-attach--files--item mb-3"
                [ngClass]="itemErrorIndexes.includes(i) ? itemErrorClass : ''">
                <div
                  class="flex justify-content-between w-full relative form-fields--file-attach--files--selected pt-1">
                  <div
                    class="absolute flex align-items-center justify-content-center form-fields--file-attach--files--selected--check">
                    <app-cigna-icon icon="ok" class="size-16"></app-cigna-icon>
                  </div>
                  <span class="s-bold form-fields--file-attach--files--selected--name">
                    {{ file.name }}
                  </span>
                  <span class="xs-regular form-fields--file-attach--files--selected--size">
                    {{ fileSize(file.size) }}
                  </span>
                  <div
                    class="absolute flex align-items-center justify-content-center cursor-pointer form-fields--file-attach--files--selected--close"
                    (click)="fileRemoved.emit(i)"
                    (keyup.enter)="fileRemoved.emit(i)"
                    tabindex="0">
                    <app-cigna-icon icon="cross" class="grey"></app-cigna-icon>
                  </div>
                </div>
                <ng-container
                  [ngTemplateOutlet]="fileDetailTemplate"
                  [ngTemplateOutletContext]="{ $implicit: file, index: i }" />
              </div>
            } @else {
              <div
                class="destacado-green-border flex justify-content-between w-full relative form-fields--file-attach--files--selected">
                <div
                  class="absolute flex align-items-center justify-content-center form-fields--file-attach--files--selected--check">
                  <app-cigna-icon icon="ok" class="size-16"></app-cigna-icon>
                </div>
                <span class="s-bold form-fields--file-attach--files--selected--name">
                  {{ file.name }}
                </span>
                <span class="xs-regular form-fields--file-attach--files--selected--size">
                  {{ fileSize(file.size) }}
                </span>
                <div
                  class="absolute flex align-items-center justify-content-center cursor-pointer form-fields--file-attach--files--selected--close"
                  (click)="fileRemoved.emit(i)"
                  (keyup.enter)="fileRemoved.emit(i)"
                  tabindex="0">
                  <app-cigna-icon icon="cross" class="grey"></app-cigna-icon>
                </div>
              </div>
            }
          }
        </div>
      }
    }
  </div>
</div>
